import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  AccountHoldings = 'AccountHoldings',
  DefaultAssetAllocation = 'DefaultAssetAllocation',
  AccountPortfolio = 'AccountPortfolio',
  AkoyaAccounts = 'AkoyaAccounts',
}

export const queryKeys = {
  accountHoldings: (clientId: number, accountId: string) => [
    QueryFeature.Profile,
    QueryKey.AccountHoldings,
    clientId,
    accountId,
  ],

  accountPortfolio: (clientId: number, accountId?: string) => [
    QueryFeature.Profile,
    QueryKey.AccountPortfolio,
    clientId,
    accountId,
  ],

  defaultAssetAllocation: (clientId: number) => [
    QueryFeature.Profile,
    QueryKey.AccountHoldings,
    QueryKey.DefaultAssetAllocation,
    clientId,
  ],

  akoyaAccounts: (clientId: number) => [QueryFeature.Profile, QueryKey.AkoyaAccounts, clientId],
};
